<template>
  
  <div>

    <div class="p-3" align="right">
      <div
        class="btn-group"
        role="group"
        v-if="permissions.includes('manage_candidates')">
        <button
          type="button"
          class="btn btn-sm"
          :class="{'btn-primary': editMode, 'btn-light': !editMode}"
          @click="editMode = !editMode">
          <i class="fas fa-pencil-alt" />
          {{ editMode ? $t('End editing') : $t('Edit profile') }}
          </button>
        <div class="btn-group" role="group">
          <button
            type="button"
            class="btn btn-sm btn-light dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            </button>
          <div
            class="dropdown-menu">
            <button
              type="button"
              class="dropdown-item"
              @click="deleteCandidate(candidate._id)">
              {{ $t('Remove candidate') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="card"
      style="border: 0">
      <div v-if="candidateJobId">
        <CandidateProfileRefer :editMode="editMode" />
        <CandidateProfileHired :editMode="editMode" />
        <CandidateProfileMatchDescription />      
        <CandidateProfileAnswers :editMode="editMode" />
      </div>
      <!--<CandidateProfileGDPR v-if="gdprEnable" />-->
      <CandidateProfileContacts :editMode="editMode" />
      <CandidateProfilePages :editMode="editMode" />
      <CandidateProfileDetails :editMode="editMode" />
      <CandidateProfileDisability :editMode="editMode" />
      <CandidateProfileSalary :editMode="editMode" />
      <CandidateProfileLanguages :editMode="editMode" />
      <CandidateProfileCoverLetter :editMode="editMode" />
      <CandidateProfileEducations :editMode="editMode" />
      <CandidateProfileExperience :editMode="editMode" />
      <!--<CandidateProfileSkills :editMode="editMode">-->
      <div v-if="customFieldGroups">
        <CandidateProfileCustomFields
          v-for="(group, index) in customFieldGroups"
          :key="index"
          :title="group.name"
          :fields="group.custom_fields"
          :editMode="editMode" />
      </div>
      <CandidateProfileControl :editMode="editMode" />
      <CandidateProfileResume :editMode="editMode" />

    </div>

  </div>
  
</template>

<script>
import CandidateProfileDetails from './CandidateProfileDetails'
import CandidateProfileDisability from './CandidateProfileDisability'
import CandidateProfileContacts from './CandidateProfileContacts'
import CandidateProfileSkills from './CandidateProfileSkills'
import CandidateProfilePages from './CandidateProfilePages'
import CandidateProfileSalary from './CandidateProfileSalary'
import CandidateProfileEducations from './CandidateProfileEducations'
import CandidateProfileExperience from './CandidateProfileExperience'
import CandidateProfileCoverLetter from './CandidateProfileCoverLetter'
import CandidateProfileResume from './CandidateProfileResume'
import CandidateProfileLanguages from './CandidateProfileLanguages'
import CandidateProfileControl from './CandidateProfileControl'
import CandidateProfileRefer from './CandidateProfileRefer'
import CandidateProfileHired from './CandidateProfileHired'
import CandidateProfileAnswers from './CandidateProfileAnswers'
import CandidateProfileMatchDescription from './CandidateProfileMatchDescription'
import CandidateProfileGDPR from './CandidateProfileGDPR'
import CandidateProfileCustomFields from './CandidateProfileCustomFields'

export default {
  name: 'CandidateProfile',
  components: {
    CandidateProfileDetails,
    CandidateProfileDisability,
    CandidateProfileContacts,
    CandidateProfileSkills,
    CandidateProfilePages,
    CandidateProfileSalary,
    CandidateProfileEducations,
    CandidateProfileExperience,
    CandidateProfileCoverLetter,
    CandidateProfileResume,
    CandidateProfileLanguages,
    CandidateProfileRefer,
    CandidateProfileHired,
    CandidateProfileAnswers,
    CandidateProfileMatchDescription,
    CandidateProfileControl,
    CandidateProfileGDPR,
    CandidateProfileCustomFields
  },
  data () {
    return {
      customFieldGroups: false,
      editMode: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidateJobId () {
      return this.$route.query.candidate_job_id
    },
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  created () {
    this.loadCustomFields()
  },
  methods: {
    loadCustomFields () {
      this.$store
      .dispatch('getCustomFieldGroups', {
        sort: 'position',
        model_type: 'candidate'
      })
      .then((result) => {
        this.customFieldGroups = result
      })
    },
    /*
    deleteCandidate
    */
    deleteCandidate (id) {
      const deleteAction = () => {
        this.$openCandidateModal(null)
        this.$store.dispatch('deleteCandidate', id)
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction,
        message: 'Ao excluir este candidato, você removerá todos os dados relacionados. Você não verá mais nenhum relatório para este candidato.<br><br><ul class="list-group"><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todos os detalhes de contato serão excluídos</li><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todas as mensagens de e-mail serão excluídas</li><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todas as avaliações serão excluídas</li><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todos os arquivos serão excluídos</li></ul>'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfile.vue